"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockRound = void 0;
const types_1 = require("../../../types");
const getMockRound = () => __awaiter(void 0, void 0, void 0, function* () {
    const round = {
        lastTransactedAt: 0,
        participants: 0,
        publicKey: "",
        roundState: types_1.RoundState.Uninitialized,
        solAmount: 0,
        feeAmount: 0,
        roundEndsAt: 0,
        startedAt: 0,
        roundNumber: 0,
        roundValue: "0",
        winner: '',
        solInNftAmount: 0,
        contractBid: 0,
        placeholderOne: 0,
        placeholderTwo: 0,
        placeholderThree: 0
    };
    return round;
});
exports.getMockRound = getMockRound;
